import { ArrowRightIconStyles } from './ArrowRightIconStyles'
import React from 'react'
import { ArrowLeftIcon } from '../ArrowLeftIcon/ArrowLeftIcon'

export const ArrowRightIcon = (): JSX.Element => {
  return <ArrowLeftIcon className={`ArrowRightIcon ${ArrowRightIconStyles}`} />
}
